import { Environment, parseEnvName } from './environment.type';

export const environment: Environment = {
  name: 'RAVEN',
  isProduction: true,
  envName: parseEnvName('Development'),
  showEnv: parseShowEnv('True'),
  hmr: false,
  auth: {
    enabled: true,
    clientId: '140cc6e5-b477-4a0a-8bed-8fe8b9f91ea1',
  },
  build: {
    tag: '',
    branchName: 'develop',
    buildNumber: '20261103.8',
  },
  appInsights: {
    connectionString: 'InstrumentationKey=797a9acc-6de7-4068-a82a-06c8b80e5d4d;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=5cbd5459-f6c5-4b60-8fcd-73d9ad3e4c67',
  },
  backend: {
    url: '/api',
  },
  support: {
    mail: {
      to: '',
    },
  },
};

export function parseShowEnv(showEnv: string): boolean {
  return showEnv == 'True';
}
